import React from 'react';

class CurtainOpen extends React.Component {
  state = {
    type: this.props.type
  };
  render() {
    return (
      <React.Fragment>
        {this.state.type === 'open' ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 2C2.89543 2 2 2.89543 2 4V12V20C2 21.1046 2.89543 22 4 22H6C7.1015 22 8.02018 21.0955 7.98377 19.9634C7.86671 16.3238 7.12732 14.0909 6.12696 12.7458C6.0731 12.6734 6.01866 12.6037 5.96372 12.5368C7.56609 11.978 8.70203 10.9566 9.47518 9.71161C10.6097 7.8846 10.9042 5.67403 10.9777 4.04356C11.0297 2.88961 10.0888 2 9 2H6.49431H4ZM7.77613 8.6565C7.27581 9.46216 6.55671 10.1665 5.47167 10.5874C7.16417 8.10482 7.63565 5.66585 7.60356 4H8.97758C8.90519 5.51864 8.62683 7.28662 7.77613 8.6565ZM4 4H5.60349C5.63366 5.18167 5.32695 7.1178 4 9.18724V4ZM4 20V13.3906C4.16897 13.5241 4.34578 13.7022 4.52212 13.9393C5.17668 14.8194 5.8704 16.5772 5.9839 20H4ZM20 2C21.1046 2 22 2.89543 22 4V12V20C22 21.1046 21.1046 22 20 22H18C16.8985 22 15.9798 21.0955 16.0162 19.9634C16.1333 16.3238 16.8727 14.0909 17.873 12.7458C17.9269 12.6734 17.9813 12.6037 18.0363 12.5368C16.4339 11.978 15.298 10.9566 14.5248 9.71161C13.3903 7.8846 13.0958 5.67403 13.0223 4.04356C12.9703 2.88961 13.9112 2 15 2H17.5057H20ZM16.2239 8.6565C16.7242 9.46216 17.4433 10.1665 18.5283 10.5874C16.8358 8.10482 16.3644 5.66585 16.3964 4H15.0224C15.0948 5.51864 15.3732 7.28662 16.2239 8.6565ZM20 4H18.3965C18.3663 5.18167 18.673 7.1178 20 9.18724V4ZM20 20V13.3906C19.831 13.5241 19.6542 13.7022 19.4779 13.9393C18.8233 14.8194 18.1296 16.5772 18.0161 20H20Z"
              fill="#8A8B8D"
            />
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 4V19.7732L4.104 19.6807C4.69056 19.1593 5.52785 19.0292 6.245 19.3479L6.5 19.4612V4L4 4ZM8.5 4V19.4612L8.93772 19.2667C9.45485 19.0369 10.0451 19.0369 10.5623 19.2667L11 19.4612V4H8.5ZM13 4V19.4612L13.4377 19.2667C13.9549 19.0369 14.5451 19.0369 15.0623 19.2667L15.5 19.4612V4H13ZM17.5 4V19.4612L17.755 19.3479C18.4721 19.0292 19.3094 19.1593 19.896 19.6807L20 19.7732L20 4H17.5ZM2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V19.7732C22 21.4989 19.9611 22.4145 18.6713 21.268L18.5673 21.1755L16.9061 21.9138C16.6476 22.0287 16.3524 22.0287 16.0939 21.9138L14.25 21.0943L12.4061 21.9138C12.1476 22.0287 11.8524 22.0287 11.5939 21.9138L9.75 21.0943L7.90614 21.9138C7.64757 22.0287 7.35243 22.0287 7.09386 21.9138L5.43273 21.1755L5.32872 21.268C4.03893 22.4145 2 21.4989 2 19.7732V4Z"
              fill="#8A8B8D"
            />
          </svg>
        )}
      </React.Fragment>
    );
  }
}

export default CurtainOpen;
